
const sppuc = {
  state: {
    updateSppucDevice: null // 融合通信更新设备
  },
  mutations: {
    UPDATE_DEVICE: (state, data) => {
      state.updateSppucDevice = data
    }
  },
  actions: {
    sppucDeviceUpdate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('UPDATE_DEVICE', data)
      })
    }
  }
}

export default sppuc
